module.exports = __webpack_public_path__ + "img/logo-blanco-preloader.23da34ff.svg";